module.exports = __webpack_public_path__ + "img/2.060cf2e1.png";